export const carsData = [
   {
      id: 1,
      title: "Model 3",
      backgroundImg: "model-s.jpg",
      description:
         "Tesla All-Wheel Drive has two independent motors for improved redundancy, each with only one moving part for minimal maintenance and maximum durability. Unlike traditional all-wheel drive systems, they digitally control torque to the front and rear wheels for far better handling and traction control.",
      price: 41940,
      inStock: true,
      highlights: [
         "Auto Lane Change",
         "Autopark",
         "Summon",
         "Full Self-Driving Computer",
         "Traffic Light and Stop Sign Control",
      ],
      quantity: 1,
      ref: null,
   },
   {
      id: 2,
      title: "Model Y",
      inStock: true,
      backgroundImg: "model-y.jpg",
      description:
         "With the most storage space and towing capacity of any electric SUV, and seating for up to seven adults, Model X delivers maximum utility. Front doors open and close automatically, Falcon Wing doors allow for easier loading and a standard trailer hitch lets you bring your gear anywhere you go.",
      price: 57940,
      highlights: [
         "Auto Lane Change",
         "Autopark",
         "Summon",
         "Full Self-Driving Computer",

         "Traffic Light and Stop Sign Control",
      ],
      quantity: 1,
      ref: null,
   },
   {
      id: 3,
      title: "Model X",
      backgroundImg: "model-x.jpg",
      price: 108940,
      inStock: true,
      description:
         "Tesla designed Model X from the ground-up as an electric vehicle — each component, including batteries, motors and exterior aerodynamics are optimized to benefit from one another and create one of the most efficient, yet unbelievably powerful vehicles ever built.",
      highlights: [
         "Auto Lane Change",
         "Autopark",
         "Summon",
         "Full Self-Driving Computer",
         "Traffic Light and Stop Sign Control",
      ],
      quantity: 1,
      ref: null,
   },
   {
      id: 4,
      title: "Model S",

      description:
         "Tesla designed Model S from the ground-up as an electric vehicle — each component, including batteries, motors and exterior aerodynamics are optimized to benefit from one another and create one of the most efficient, yet unbelievably powerful vehicles ever built.",
      backgroundImg: "model-3.jpg",
      price: 93740,
      inStock: false,

      highlights: [
         "Navigate on Autopilot",
         "Auto Lane Change",
         "Autopark",
         "Summon",
         "Full Self-Driving Computer",
         "Traffic Light and Stop Sign Control",
      ],
      quantity: 1,
      ref: null,
   },
];
